import { render, staticRenderFns } from "./BaseFileLoadPageMixin.vue?vue&type=template&id=532a9c30&"
import script from "./BaseFileLoadPageMixin.vue?vue&type=script&lang=js&"
export * from "./BaseFileLoadPageMixin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports